import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es7.array.includes";
import "core-js/modules/es6.string.includes";
import "core-js/modules/web.dom.iterable";
import _defineProperty from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { getLazyList, remove, update, add, getMenu } from "@/api/system/menu";
import { mapGetters } from "vuex";
import iconList from "@/config/iconList";
import func from "@/util/func";
import { getMenuTree } from "@/api/system/menu";
import { queryTenantList } from "@/api/system/dictbiz";
export default {
  data: function data() {
    return {
      form: {},
      query: {},
      tenantList: [],
      tenantVal: '',
      loading: true,
      selectionList: [],
      parentId: 0,
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0
      },
      option: {
        lazy: true,
        tip: false,
        simplePage: true,
        searchShow: true,
        searchMenuSpan: 6,
        dialogWidth: "60%",
        tree: true,
        border: true,
        index: true,
        selection: true,
        viewBtn: true,
        menuWidth: 300,
        dialogClickModal: false,
        column: [{
          label: "菜单名称",
          prop: "name",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单名称",
            trigger: "blur"
          }]
        }, {
          label: "路由地址",
          prop: "path",
          rules: [{
            required: true,
            message: "请输入路由地址",
            trigger: "blur"
          }]
        }, {
          label: "上级菜单",
          prop: "parentId",
          type: "tree",
          dicData: [],
          hide: true,
          props: {
            label: "title"
          },
          rules: [{
            required: false,
            message: "请选择上级菜单",
            trigger: "click"
          }]
        }, {
          label: "菜单图标",
          prop: "source",
          type: "icon",
          slot: true,
          iconList: iconList,
          rules: [{
            required: true,
            message: "请输入菜单图标",
            trigger: "click"
          }]
        }, {
          label: "菜单编号",
          prop: "code",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单编号",
            trigger: "blur"
          }]
        }, {
          label: "菜单类型",
          prop: "category",
          type: "radio",
          dicData: [{
            label: "菜单",
            value: 1
          }, {
            label: "按钮",
            value: 2
          }],
          hide: true,
          rules: [{
            required: true,
            message: "请选择菜单类型",
            trigger: "blur"
          }]
        }, {
          label: "菜单别名",
          prop: "alias",
          search: true,
          rules: [{
            required: true,
            message: "请输入菜单别名",
            trigger: "blur"
          }]
        }, {
          label: "菜单排序",
          prop: "sort",
          type: "number",
          rules: [{
            required: true,
            message: "请输入菜单排序",
            trigger: "blur"
          }]
        }, {
          label: "菜单备注",
          prop: "remark",
          type: "textarea",
          span: 24,
          minRows: 2,
          hide: true
        }]
      },
      data: []
    };
  },
  watch: {
    'form.category': function formCategory() {
      var category = func.toInt(this.form.category);
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "path") {
          item.rules[0].required = category === 1;
        }
      });
    }
  },
  computed: _objectSpread(_objectSpread({}, mapGetters(["userInfo", "permission"])), {}, {
    permissionList: function permissionList() {
      return {
        addBtn: this.vaildData(this.permission.menu_add, false),
        viewBtn: this.vaildData(this.permission.menu_view, false),
        delBtn: this.vaildData(this.permission.menu_delete, false),
        editBtn: this.vaildData(this.permission.menu_edit, false)
      };
    },
    ids: function ids() {
      var ids = [];
      this.selectionList.forEach(function (ele) {
        ids.push(ele.id);
      });
      return ids.join(",");
    }
  }),
  methods: {
    initData: function initData() {
      var _this = this;

      getMenuTree().then(function (res) {
        var column = _this.findObject(_this.option.column, "parentId");

        column.dicData = res.data.data;
      });
    },
    getTenantList: function getTenantList() {
      var _this2 = this;

      if (!this.tenantVal) {
        queryTenantList().then(function (res) {
          console.log(res, '--res');
          _this2.tenantList = res.data.data;
          _this2.tenantVal = _this2.tenantList[0].tenantId;
        });
      }
    },
    handleAdd: function handleAdd(row) {
      this.$refs.crud.value.parentId = row.id;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = row.id;
          item.addDisabled = true;
        }
      });
      this.$refs.crud.rowAdd();
    },
    rowSave: function rowSave(row, done, loading) {
      var _this3 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      add(data).then(function (res) {
        // 获取新增数据的相关字段
        var data = res.data.data;
        row.id = data.id;

        _this3.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowUpdate: function rowUpdate(row, index, done, loading) {
      var _this4 = this;

      var data = Object.assign({}, row, {
        tenantId: this.tenantVal
      });
      update(data).then(function () {
        _this4.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      }, function (error) {
        window.console.log(error);
        loading();
      });
    },
    rowDel: function rowDel(row, index, done) {
      var _this5 = this;

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(row.id);
      }).then(function () {
        _this5.$message({
          type: "success",
          message: "操作成功!"
        }); // 数据回调进行刷新


        done(row);
      });
    },
    handleDelete: function handleDelete() {
      var _this6 = this;

      if (this.selectionList.length === 0) {
        this.$message.warning("请选择至少一条数据");
        return;
      }

      this.$confirm("确定将选择数据删除?", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).then(function () {
        return remove(_this6.ids);
      }).then(function () {
        // 刷新表格数据并重载
        _this6.data = [];
        _this6.parentId = 0;

        _this6.$refs.crud.refreshTable();

        _this6.$refs.crud.toggleSelection(); // 表格数据重载


        _this6.onLoad(_this6.page);

        _this6.$message({
          type: "success",
          message: "操作成功!"
        });
      });
    },
    searchReset: function searchReset() {
      this.query = {};
      this.parentId = 0;
      this.onLoad(this.page);
    },
    searchChange: function searchChange(params, done) {
      this.query = params;
      this.parentId = '';
      this.page.currentPage = 1;
      this.onLoad(this.page, params);
      done();
    },
    selectionChange: function selectionChange(list) {
      this.selectionList = list;
    },
    selectionClear: function selectionClear() {
      this.selectionList = [];
      this.$refs.crud.toggleSelection();
    },
    beforeOpen: function beforeOpen(done, type) {
      var _this7 = this;

      if (["add", "edit"].includes(type)) {
        this.initData();
      }

      if (["edit", "view"].includes(type)) {
        getMenu(this.form.id, this.tenantVal).then(function (res) {
          _this7.form = res.data.data;
        });
      }

      done();
    },
    beforeClose: function beforeClose(done) {
      this.$refs.crud.tableForm = {};
      this.$refs.crud.value.parentId = "";
      this.$refs.crud.value.addDisabled = false;
      this.$refs.crud.option.column.filter(function (item) {
        if (item.prop === "parentId") {
          item.value = "";
          item.addDisabled = false;
        }
      });
      done();
    },
    currentChange: function currentChange(currentPage) {
      this.page.currentPage = currentPage;
    },
    sizeChange: function sizeChange(pageSize) {
      this.page.pageSize = pageSize;
    },
    refreshChange: function refreshChange() {
      this.onLoad(this.page, this.query);
    },
    onLoad: function onLoad(page) {
      var _this8 = this;

      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      this.getTenantList();
      this.loading = true;
      getLazyList(this.parentId, Object.assign(params, this.query, {
        tenantId: this.tenantVal
      })).then(function (res) {
        _this8.data = res.data.data;
        _this8.loading = false;

        _this8.selectionClear();
      });
    },
    treeLoad: function treeLoad(tree, treeNode, resolve) {
      var parentId = tree.id;
      getLazyList(parentId, {
        tenantId: this.tenantVal
      }).then(function (res) {
        resolve(res.data.data);
      });
    }
  }
};